// extracted by mini-css-extract-plugin
export default {"Filter":"filter_Filter__pQqxg"};